module.exports = __webpack_public_path__ + "img/1.fbbf3819.jpg";